import React, { useState, useEffect } from "react";

// Modules
import { useDispatch, useSelector } from "react-redux";

// App

import isLoggedIn from "../../../core/isLoggedIn";
import getUser from "../../../core/getUser";
import { generateStateToken, saveStateToken } from "../../../utils/helpers";
import { getOnlineNode } from "../../../core/getNode";

// UI
import { Box, Button, Alert, CircularProgress } from "@mui/material";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import { InfoOutlined } from "@mui/icons-material";
import { Row, Col } from "react-bootstrap";

const CustomWidthTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 500,
  },
});

export default function SSOAuth() {
  // hooks
  const dispatch = useDispatch();

  /** redux */
  const system = useSelector((state) => state).systemReducer;

  const [isLoading, setLoading] = useState(true);
  const [isError, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [clientInfo, setClientInfo] = useState({
    endpoint: null,
    server_authentication_endpoint: null,
  });

  const isRun = sessionStorage.getItem("oauth2-run");

  useEffect(() => {
    isLoggedIn().then((isLoggedIn) => {
      if (isLoggedIn) {
        fetchUser();
      } else {
        getClientInfo();
      }
    });
  }, []);

  const fetchUser = () => {
    getUser().then((data) => {
      if (data) {
        dispatch({ type: "SAVE_SESSION", payload: data });
      } else {
        dispatch({ type: "REMOVE_SESSION", payload: {} });
      }
    });
  };

  const getClientInfo = () => {
    const path = `/openid_connect_rest_auth/authorization_endpoint/adfs?redirect_uri=${window.location.origin}${window.location.pathname}`;

    getOnlineNode(path)
      .then((response) => {
        setClientInfo(response.data);
        setLoading(false);
      })
      .catch(() => {
        setErrorMessage("Failed to get client info");
        setError(true);
        setLoading(false);
      });
  };

  const login = () => {
    if (clientInfo.endpoint) {
      window.location.href = clientInfo.endpoint;
    } else {
      setErrorMessage("No endpoint defined");
      setError(true);
    }
  };

  const Error = () => {
    return (
      <>
        {isError && (
          <>
            {errorMessage && (
              <Col xs="auto" className="mb-4">
                <Alert variant="filled" severity="error">
                  {errorMessage}
                </Alert>
              </Col>
            )}
          </>
        )}
      </>
    );
  };

  const ADFSButton = () => {
    return (
      <Box>
        <Button onClick={login} variant="contained" sx={{ textTransform: "none" }}>
          via RHG Rezportal
          <CustomWidthTooltip
            title="This button will take you to an external webpage to log in. Once you've logged in successfully, you will be re-directed back to the app."
            arrow
          >
            <InfoOutlined sx={{ marginLeft: "5px" }} fontSize="14" />
          </CustomWidthTooltip>
        </Button>
      </Box>
    );
  };

  const Loading = () => {
    return (
      <Row>
        <Col className="text-center">
          <CircularProgress size={20} />
        </Col>
      </Row>
    );
  };

  return (
    <>
      <main className={`login screen d-flex flex-column align-items-center`}>
        {isLoading ? (
          <Loading />
        ) : (
          <Row className={`g-0 w-50 mb-3 justify-content-center`}>
            <Col xs="auto">{isError ? <Error /> : <ADFSButton />}</Col>
          </Row>
        )}
      </main>
    </>
  );
}
